export const INVITE_BANNER_DISMISSED_KEY = "account_invite_banner_dismissed";
export const UPGRADE_BANNER_DISMISSED_KEY = "account_upgrade_banner_dismissed";
const ls = window.localStorage

/**
 * @description whether the user dismissed the "Working with others?" banner on the Account pages
 */
export const isInviteBannerDismissed = (): boolean => {
  return ls.getItem(INVITE_BANNER_DISMISSED_KEY) === "1";
};

/**
 * @description remember that the user dismissed the "Working with others?" banner
 */
export const dismissInviteBanner = (): void => {
  ls.setItem(INVITE_BANNER_DISMISSED_KEY, "1");
};

/**
 * @description whether the user dismissed the free tier "Upgrade" banner on the Account pages
 */
export const isUpgradeBannerDismissed = (): boolean => {
  return ls.getItem(UPGRADE_BANNER_DISMISSED_KEY) === "1";
};

/**
 * @description remember that the user dismissed the free tier "Upgrade" banner
 */
export const dismissUpgradeBanner = (): void => {
  ls.setItem(UPGRADE_BANNER_DISMISSED_KEY, "1");
};

export default { isInviteBannerDismissed, dismissInviteBanner, isUpgradeBannerDismissed, dismissUpgradeBanner };
